import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { EditableModuleAndSection } from '../types';

export class PoliciesSelectorBaseDataProvider extends BaseWebComponentDataProvider {
  async getPolicies(editableModuleAndSection: EditableModuleAndSection): Promise<any> {
    throw new Error('Not implemented');
  }
}
